
import { computed, defineComponent } from 'vue';
import useApp from '@/composables';

export default defineComponent({
    name: 'Header',
    components: {},
    setup() {
        const { state, toggleFilterStatus } = useApp();

        const classifications = [
            {
                color: 'red',
                title: 'Contaminated Sites, Upstream',
                code: 'CSU'
            },
            {
                color: 'green',
                title: 'Reclamation Certificates',
                code: 'REC'
            },
            {
                color: 'orange',
                title: 'Petroleum Storage Tank',
                code: 'PST'
            },
            {
                color: 'blue',
                title: 'Site Assessments, Contaminated Sites, Cleanup, Decommissioning Facilities',
                code: 'SCD'
            }
        ];

        const selectedClassification = computed(() => state.filteredStatusCode);

        return {
            selectedClassification,
            toggleFilterStatus,
            classifications
        };
    }
});
